// // src/services/api.ts
// import axios from 'axios';

// const api = axios.create({
//     baseURL: 'http://localhost:3400/api/v1', // Substitua pela URL correta da sua API
// });

// export default api;


import axios from 'axios';
import { useState } from 'react';
import { clearSession, getToken } from '../auth/session';

const url = process.env.REACT_APP_SERVER_URL;
console.log('URL:', url);



const api = axios.create({
    baseURL: url + '/api/v1',
});


// Interceptor para adicionar o token no cabeçalho
api.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


api.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response?.status === 401 && error.response.data.message !== 'Primeiro acesso não autorizado!') {
            // Remove o token

            if (window.location.pathname !== '/login') {

                clearSession();

                // Redireciona para o login
                window.location.href = '/login';
            }

            // Retorna um erro explícito (opcional)
            return Promise.reject(new Error('Sessão expirada. Redirecionando para login.'));
        }

        return Promise.reject(error);
    }
);

export default api;
